import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import BackButton from "../../../../../components/BackButton";
import routes from "../../../../../routes/routes";

interface Props {
  /** Explicit back target; if omitted we infer based on presence of serviceId */
  to?: string;
  hidden?: boolean;
}

const KeyHandoverNavigateBackAction: React.FC<Props> = ({ to, hidden = false }) => {
  const navigate = useNavigate();
  const location = useLocation();
  // Infer previous step from current pathname when `to` isn't provided
  let inferred = routes.keyHandoverLocationSelectionPath;
  if (location.pathname === routes.keyHandoverSchedulePath) {
    inferred = routes.keyHandoverServiceSelectionPath;
  } else if (location.pathname === routes.keyHandoverReturnSchedulePath) {
    inferred = routes.keyHandoverSchedulePath;
  } else if (location.pathname === routes.keyHandoverServiceSelectionPath) {
    inferred = routes.keyHandoverLocationSelectionPath;
  }

  const target = to || inferred;
  return (
    <BackButton hidden={hidden} onClick={() => navigate({ pathname: target, search: location.search })} />
  );
};

export default KeyHandoverNavigateBackAction;
